export default function () {
  if (document.getElementById('proposal-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "proposal-offers-app" */ '../../_03_organisms/offer/proposal/main'
    );
  }
}
